import React from 'react';
type UnitIconProps = {
  id: 'school' | 'people' | 'apple';
  className?: string;
};
export function UnitIcon({
  id,
  className = 'stroke-petrol'
}: UnitIconProps) {
  return <svg viewBox="0 0 64 64" aria-hidden="true" className={`h-full w-full fill-none [stroke-linecap:round] [stroke-linejoin:round] [stroke-width:2.5] ${className}`} data-id="element-247" data-mp="3puyr3bw1nz37">
      {id === 'school' && <path d="M9 28 32 10l23 18M15 25v31h34V25M27 56V39h10v17M21 30h5m12 0h5M28 18h8" data-id="element-248" data-mp="lgihlagjkwun" />}
      {id === 'people' && <>
          <circle cx="20" cy="18" r="8" data-id="element-249" data-mp="hggh34mjm9gy" />
          <circle cx="45" cy="23" r="7" data-id="element-250" data-mp="hhj8rerowfxx" />
          <path d="M5 51v-8a15 15 0 0 1 30 0v8M36 52v-7a11 11 0 0 1 22 0v7" data-id="element-251" data-mp="cnnfgpmdfh93" />
        </>}
      {id === 'apple' && <path d="M32 21c-16-12-32 5-24 23 8 19 17 12 24 12s16 7 24-12c8-18-8-35-24-23ZM32 22c-2-11 3-17 8-20M35 12c12 1 18-4 20-9-12-2-19 3-20 9" data-id="element-252" data-mp="7ou7tdtrmkgu" />}
    </svg>;
}